import { Box, FormControlLabel } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseAutocomplete from 'common/components/base-autocomplete';
import { BpRadio } from 'common/components/base-radio-group';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
interface IProps {
    name: string;
    options: { label: string; value: string }[];
}
const QuestionTextboxRecommend: React.FC<IProps> = ({ name, options }) => {
    const { watch } = useFormContext();
    return (
        <BaseAutocomplete
            name={name}
            isOptionEqualToValue={(option, value) =>
                option.value === value.value
            }
            endAdornment={
                <SearchIcon
                    sx={{
                        fontSize: [28, 34],
                        color: '#8B8B8B',
                    }}
                />
            }
            multiple={false}
            popupIcon={null}
            disableClearable
            sx={{
                '& .MuiInputBase-root': {
                    height: ['3.5rem', '3.5rem', '4rem', '5rem', '5rem'],
                    fontSize: ['1rem', '1rem', '1.5rem', '1.5rem', '1.7rem'],
                    fontWeight: '400',
                    borderRadius: '10px',
                    backgroundColor: common.white,
                    paddingRight: '1rem !important',
                },
            }}
            options={options}
            renderOption={(props, option) => {
                return (
                    <Box component="li" {...props}>
                        <FormControlLabel
                            value={option?.value}
                            control={<BpRadio />}
                            label={option?.label}
                            checked={option?.value === watch(name)?.value}
                        />
                    </Box>
                );
            }}
        />
    );
};

export default QuestionTextboxRecommend;
